import React, { useEffect, useRef } from 'react';

import './styles.css';

export type BackdropMode = 'display' | 'clickable' | 'none';

interface Classes {
	backdropContainer: string;
	backdrop: string;
}

interface Props {
	open: boolean;
	exited: boolean;
	classes?: Partial<Classes>;
	transitionDuration?: any;
	onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
}

function restoreOverflowX(valueRef: React.MutableRefObject<string | undefined>, body: HTMLElement) {
	if (valueRef.current) {
		body.style.overflowX = valueRef.current;
		valueRef.current = undefined;
	} else {
		body.style.removeProperty('overflow-x');
	}
}

const Backdrop: React.FC<Props> = (props) => {
	const { open, exited, onClick, children } = props;
	const rootRef = useRef(null);
	const overflowX = useRef<string>();

	const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
		if (onClick) {
			onClick(e);
		}
	};

	useEffect(() => {
		let body: HTMLElement;
		if (rootRef.current) {
			body = document.body;
			if (open) {
				if (body.style.overflowX) {
					overflowX.current = body.style.overflowX;
				}
				body.style.overflowX = 'hidden';
			} else if (exited) {
				restoreOverflowX(overflowX, body);
			}
		}

		return () => {
			if (!open && body) {
				restoreOverflowX(overflowX, body);
			}
		};
	}, [open, exited]);

	if (!open && exited) {
		return null;
	}

	const containerClasses = 'containerClasses';

	const backdropClasses = 'backdropClasses';

	return (
		<div className={containerClasses} ref={rootRef}>
			<div role="presentation" onClick={handleClick} className={backdropClasses}>
				{children}
			</div>
		</div>
	);
};

export default React.memo(Backdrop);
